import React, { useEffect, useRef, useState } from 'react';
import { Snackbar, Alert, Typography } from '@mui/material';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import { useTranslation } from 'react-i18next';
import useOnlineStatus from '../hooks/useOnlineStatus';

// Shows a persistent banner while offline, and a brief "back online" confirmation.
export default function OfflineIndicator() {
  const online = useOnlineStatus();
  const { t } = useTranslation();
  const [showReconnected, setShowReconnected] = useState(false);
  const wasOffline = useRef(false);

  useEffect(() => {
    if (!online) {
      wasOffline.current = true;
    } else if (wasOffline.current) {
      wasOffline.current = false;
      setShowReconnected(true);
    }
  }, [online]);

  return (
    <>
      <Snackbar
        open={!online}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {/* SEVERITY IS "info", NOT "warning". Being offline is not a degraded
            state to be warned about — the app keeps working — and an amber
            alert every time a school's connection dips trains people to ignore
            the banner that does matter.

            THREE WORDS, not a paragraph. This sat permanently across the foot
            of the page for as long as the connection was down, explaining that
            work is saved locally and which two actions need a connection.
            Nobody reads that twice, and it appears every time a signal drops.
            That the app keeps working is something a person learns by carrying
            on and finding that it does; the count of changes waiting to send is
            the part that is actual news, and it has its own indicator. */}
        <Alert severity="info" icon={<CloudOffIcon fontSize="small" />} variant="filled" sx={{ width: '100%' }}>
          <Typography variant="body2">
            {t('offline.banner', { defaultValue: "You're offline" })}
          </Typography>
        </Alert>
      </Snackbar>

      <Snackbar
        open={showReconnected}
        autoHideDuration={3000}
        onClose={() => setShowReconnected(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="success" variant="filled" sx={{ width: '100%' }} onClose={() => setShowReconnected(false)}>
          {t('offline.reconnected', { defaultValue: 'Back online. Sending your changes.' })}
        </Alert>
      </Snackbar>
    </>
  );
}
